import React from "react";
import { TextField, Tooltip, IconButton, Box, Checkbox, FormControlLabel } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

function handleKeyDown(e, config) {
	const controlKeys = ["Backspace", "Tab", "Delete", "ArrowLeft", "ArrowRight", "Home", "End"];
	if (controlKeys.includes(e.key)) return;

	if (config.type === "number") {
		const validChars = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
		if (config.allowDecimal) validChars.push(".");

		if (!validChars.includes(e.key)) {
			e.preventDefault();
		}
	} else if (config.type === "text" && config.regex) {
		if (!config.regex.test(e.key)) {
			e.preventDefault();
		}
	}
}

const FormConfig = ({
	labels,
	handleFieldChange,
	valorDefault = {},
	tooltips,
	errors,
	fieldConfigs = {},
}) => {
	const FieldChange = (label, value) => {
		if (handleFieldChange) {
			handleFieldChange(label, value);
		}
	};

	return (
		<>
			{labels.map((label, index) => {
				const config = fieldConfigs[label] || {};
				const { type = "text", dependsOn, dependsValue } = config;

				let disabled = false;
				if (dependsOn) {
					const requiredValue = dependsValue ?? "true";
					const actualValue = valorDefault[dependsOn];
					disabled = actualValue !== requiredValue;
				}

				if (type === "checkbox") {
					// En lugar de sólo checar === "true"
					const checked = valorDefault[label] === "true" || valorDefault[label] === true;

					return (
						<FormControlLabel
							key={index}
							control={
								<Checkbox
									checked={checked}
									onChange={(e) => FieldChange(label, e.target.checked ? "true" : "false")}
								/>
							}
							label={label}
							sx={{ mb: 2 }}
						/>
					);
				} else {
					return (
						<Box display="flex" alignItems="center" key={index} width="100%">
							<TextField
								sx={{ mb: 2, width: "100%" }}
								size="medium"
								label={label}
								value={valorDefault[label] ?? ""}
								error={!!errors[label]}
								helperText={errors[label]}
								onKeyDown={(e) => handleKeyDown(e, config)}
								onChange={(e) => FieldChange(label, e.target.value)}
								disabled={disabled}
								InputProps={{
									endAdornment: (
										<Tooltip title={<span style={{ fontSize: "1.5vh" }}>{tooltips[index]}</span>} arrow>
											<IconButton>
												<InfoOutlinedIcon />
											</IconButton>
										</Tooltip>
									),
								}}
							/>
						</Box>
					);
				}
			})}
		</>
	);
};

export default FormConfig;
